<template>
  <ion-footer>
    <ion-toolbar>
      <div class="row mb-0 p-2">
        <div class="col-12 text-center">
          <p class="font-15 mb-1">กรุณาชำระเงินภายใน <strong class="color-blue-dark">{{ timerExp.min }}:{{ timerExp.sec }}</strong> นาที</p>
        </div>
        <div class="col-5">
          จำนวนที่เลือก<br>
          <strong class="color-blue-dark font-15">{{ carts.length }}</strong> ชุด (สูงสุด 20 ชุด)
        </div>
        <div class="col-7">
          <ion-nav-link router-direction="forward" :component="component"
                        class="btn btn-full mb-3 rounded-xl text-uppercase font-15 shadow-s bg-btn-default w-100">
            ตรวจสอบสลากฯ
          </ion-nav-link>
        </div>
      </div>
    </ion-toolbar>
  </ion-footer>
</template>

<script>
import {IonNavLink, IonFooter, IonToolbar} from "@ionic/vue";
import CartIndex from "@/views/cart/Index";

export default {
  name: 'CartFooter',
  components: {
    IonNavLink,
    IonFooter,
    IonToolbar
  },
  props: {
    carts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      component: CartIndex,
      timerExp: {
        sec: "00",
        min: "00",
        hour: "00",
        day: "00"
      },
      loop_exp_cd: null,
    }
  },
  async mounted() {
    await this.timerExpCart();
    if (this.carts.length > 0) {
      this.loop_exp_cd = setInterval(() => {
        this.timerExpCart()
      }, 1000)
    }
  },
  beforeUnmount() {
    clearInterval(this.loop_exp_cd);
  },
  methods: {
    resetTimerExp() {
      this.timerExp = {
        sec: "00",
        min: "00",
        hour: "00",
        day: "00"
      };
    },
    async clearExpiredCart() {
      clearInterval(this.loop_exp_cd);
      this.loop_exp_cd = null;
      this.resetTimerExp();
      await this.storage.set('carts', []);
      await this.storage.set('cart_exp', null);
      this.emitter.emit('toggle-cart');
      this.emitter.emit('update-cart');
    },
    async timerExpCart() {
      const exp = await this.storage.get('cart_exp');
      if (!exp) {
        if (this.carts.length > 0) {
          await this.clearExpiredCart();
        }
        return;
      }

      const now = this.moment(new Date()); //todays date
      const end = this.moment(exp); // another date
      if (!end.isValid() || now.isSameOrAfter(end)) {
        await this.clearExpiredCart();
        return;
      }

      const duration = this.moment.duration(end.diff(now));
      if (duration.minutes() == 5 && duration.seconds() == 0) {
        // this.$swal.fire("เหลือเวลา 5 นาทีสุดท้าย", "ใกล้หมดเวลาแล้ว กรุณากดยืนยันคำสั่งซื้อเพื่อชำระเงินก่อนหมดเวลา ", "warning")
      }

      this.timerExp.sec = duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds();
      this.timerExp.min = duration.minutes() < 10 ? `0${duration.minutes()}` : duration.minutes();
      this.timerExp.hour = duration.hours() < 10 ? `0${duration.hours()}` : duration.hours();
      this.timerExp.day = duration.days() < 10 ? `0${duration.days()}` : duration.days();
    }
  }
}
</script>

<style scoped>

</style>
